import { render } from "./citizen.vue?vue&type=template&id=25d7304a"
import script from "./citizen.vue?vue&type=script&lang=js"
export * from "./citizen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__